import request from '@/utils/request'

let Huigou_zoneApi = {

  /*惠购专区列表*/
  list(data) {
    return request._post('/shop/plus.huigou_zone.Index/index', data);
},
/*添加惠购专区*/
add(data) {
    return request._post('/shop/plus.huigou_zone.Index/add', data);
},
/*修改惠购专区*/
edit(data) {
    return request._post('/shop/plus.huigou_zone.Index/edit', data);
},
/*删除惠购专区*/
del(data) {
    return request._post('/shop/plus.huigou_zone.Index/del', data);
},
/*惠购专区详情*/
detail(data) {
  return request._post('/shop/plus.huigou_zone.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.huigou_zone.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.huigou_zone.Setting/getSetting', data, errorback);
    },
}
export default Huigou_zoneApi;



// WEBPACK FOOTER //
// ./src/api/huigou_zone.js